import { Pipe, PipeTransform } from '@angular/core';
import { Card } from '../models/card.model';

@Pipe({
  name: 'filterCards'
})

// Filter for just 1 card that is equal to the search

export class FilterCardsPipe implements PipeTransform {
  transform(cards: Card[], searchText: string): Card {
    if(!cards) return cards[0];
    if(!searchText) return cards[0];
    return cards.filter( card => {
      return card.id.toString() === searchText
    })[0];
  }
}

// Filter for all cards that includes the search

// export class FilterCardsPipe implements PipeTransform {
//   transform(cards: Card[], searchText: string): Card[] {
//     if(!cards) return [];
//     if(!searchText) return cards;
//     return cards.filter( card => {
//       // return card.id.toString().includes(searchText);
//       return card.id.toString() === searchText
//     });
//   }
// }



// WEBPACK FOOTER //
// ./src/app/shared/services/filter-service.pipe.ts